export default __webpack_public_path__ + "static/media/oneofzero.29ee045e.png";